import { MAP_ICONS, MAP_ICONS_NAMES } from 'utils';
import { SATISFACTION_LEVELS } from 'modules/admin-panel/pages/results/utils';
import { CONSTANTS } from 'modules/admin-panel/utils';

export const getMapIcon = (
	satisfaction: number | null,
	prevSatisfaction?: number | null,
) => {
	if (satisfaction === null) {
		return MAP_ICONS[MAP_ICONS_NAMES.dotGrey];
	}

	let dotKey = MAP_ICONS_NAMES.dotRed;

	if (satisfaction >= SATISFACTION_LEVELS.ok.min) {
		dotKey = MAP_ICONS_NAMES.dotYellow;
	}

	if (satisfaction >= SATISFACTION_LEVELS.good.min) {
		dotKey = MAP_ICONS_NAMES.dotGreen;
	}

	if (prevSatisfaction === undefined) return MAP_ICONS[dotKey];

	if (satisfaction + CONSTANTS.noMatterDelta < (prevSatisfaction || 0)) {
		dotKey += MAP_ICONS_NAMES.negative;
	} else if (satisfaction > (prevSatisfaction || 0) + CONSTANTS.noMatterDelta) {
		dotKey += MAP_ICONS_NAMES.positive;
	} else {
		dotKey += MAP_ICONS_NAMES.neutral;
	}

	return MAP_ICONS[dotKey];
};
